/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {QcOutputDocumentTypeResponse} from '../models/QcOutputDocumentTypeResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class QcOutputDocumentTypeInternalService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Returns the calling organization's configured Post-Closing QC output document type.
   * @returns QcOutputDocumentTypeResponse OK
   * @throws ApiError
   */
  public qcOutputDocumentTypeInternalGetQcOutputDocumentType(): CancelablePromise<QcOutputDocumentTypeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/internal/qc/output-document-type',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
}
